module.exports = __webpack_public_path__ + "static/media/tel.27a9ea78.mp3";